/* eslint-disable import/first */
import React, { Component } from "react";
import { isEmpty, isString, get, isNil } from "lodash";
import PropTypes from "prop-types";
import { Loading, Message, Button } from "@alifd/next";
import DeviceSdk from "@alife/devicetasksdk";
import request from "@ali/request-olympics";
import setRequestParams from "./addons/request/setRequestParams";
import Form from "./components/Form";
import GlobalMessage from "./components/GlobalMessage";
import FormNav from "./components/FormNav";
import ErrorTab from "./components/ErrorTab";
import { NavBar } from "./components/Step";
import SimpleForm from "./form";
import Cookies from 'js-cookie'; // 添加这个导入
import { UnionDetailForm, UnionForm } from "./union-form";

import "@alife/devicetasksdk/lib/index.scss";
import "./index.scss";

export { SimpleForm, UnionForm, UnionDetailForm };

// 注册一些依赖包信息
window.__FORM_RENDER_DEPS__ = __FORM_RENDER_DEPS__ || {};

class ReceptForm extends Component {
  constructor(props) {
    super(props);
    this.cachedFieldValues = {}; // 缓存所有输入字段的值，避免切页丢失
    this.formInstance = null;
    this.formLoadingTimer = null;
    this.state = {
      schema: null,
      groups: [],
      errorList: [],
      globalErrorList: [],
      errorListVisible: false,
      loading: true,
      pages: [],
      currentPage: 0,
      PageMode: "normal",
      isEdit: false,
      sdkVisible: false,
      sdkStatus: "",
      formLoading: false, // 用于控制表单区域的loading效果，与loading状态有区别，loading是控制初始化加载渲染状态

      // todo 测试待删
      fieldsSelectModeStatus: false,
      fieldsSelectModeData: [],
    };
    const { params = {} } = props;
    setRequestParams({ mock: params.mock });

    // todo 测试代码，要删掉
    this.getFieldsSelectData = this.getFieldsSelectData.bind(this);

    this.onFieldsSelectChange = this.onFieldsSelectChange.bind(this);

    // todo 测试代码，需要删除
    this.setFieldsSelectData = this.setFieldsSelectData.bind(this);
  }

  componentDidMount () {
    const markCookie = Cookies.get('mark');
    console.log("读取到了 mark cookie:", markCookie);

    if (markCookie === 'user') {
      // mark=user：全部清空，但保留接口返回的用户填写字段
      this._loadFormWithMarkUser();
    } else if (markCookie === 'false') {
      // mark=false：不授权场景，按字段对比智能清空
      this._loadFormWithMarkFalse();
    } else {
      // 无 mark cookie：正常加载
      this._loadFormNormal();
    }
  }

  // mark=user 场景：加载表单后全量清空，但保留用户填写的字段
  _loadFormWithMarkUser = () => {
    const { params, onLoad, renderUrl, headers, detail } = this.props;
    // timeType=true 表示首次进入，由外部设置 cookie，用完立即删除
    const isFirstTime = Cookies.get('timeType') === 'true';
    if (isFirstTime) {
      Cookies.remove('timeType', { domain: '.banshi.beijing.gov.cn', path: '/' });
    }

    request({
      url: renderUrl,
      method: "GET",
      headers: { ...headers },
      data: {
        ...params,
        detail: detail ? 1 : undefined,
        t: Date.now(),
      },
    }).then(async (response) => {
      let res = (response || {}).data || response || {};
      if (!res.formSchema && response && response.data && response.data.data) {
        res = response.data.data;
      }
      let formData = isString(res.formSchema) ? JSON.parse(res.formSchema) : res.formSchema;

      if (isFirstTime) {
        // 首次进入：清空数据，保留指定字段
        const preserveFieldIds = await this.getPreserveFieldIds();
        console.log("🔑 preserveFieldIds:", [...preserveFieldIds]);
        console.log("🔑 instanceData.formData fieldIds:", formData?.instanceData?.formData?.map(f => `${f.fieldId}=${JSON.stringify(f.fieldData?.value)}`));
        formData = this.modifyFormDataForUser(formData, preserveFieldIds);
      } else {
        // 切页返回后重新 mount：从 sessionStorage 恢复用户填写的值
        if (!formData.global) formData.global = {};
        formData.global.edit = true;
        formData.global.readonly = false;
        formData.global.disabled = false;

        const processComponent = (component) => {
          if (!component) return;
          if (component.props && component.props.fieldId) {
            component.props.readonly = false;
            component.props.disabled = false;
            component.props.editable = true;
            component.props.readOnly = false;
          }
          if (component.children && Array.isArray(component.children)) {
            component.children.forEach(child => processComponent(child));
          }
        };
        if (formData.pages && Array.isArray(formData.pages)) {
          formData.pages.forEach(page => {
            if (page.layout) processComponent(page.layout);
          });
        }

        // 恢复用户填写的值
        try {
          const instanceId = formData?.instanceData?.id;
          const key = `receptFormUserValues_${instanceId || 'default'}`;
          const savedStr = sessionStorage.getItem(key);
          console.log(" 恢复 key:", key, "savedStr:", savedStr);
          if (savedStr && formData?.instanceData?.formData) {
            const savedValues = JSON.parse(savedStr);
            console.log(" savedValues:", savedValues);
            formData.instanceData.formData.forEach(field => {
              if (field.fieldId && savedValues[field.fieldId] !== undefined) {
                field.fieldData.value = savedValues[field.fieldId];
              }
            });
          }
        } catch (e) { console.error("恢复失败:", e); }
      }

      this.setState({
        loading: false,
        schema: formData,
        PageMode: get(formData, "pages[0].layout.props.mode", "normal"),
        globalMessage: formData.global && formData.global.globalMessage,
        isEdit: true,
        disableDevicePlugin: formData.global && formData.global.disableDevicePlugin,
      });
    });

    if (onLoad) onLoad(this);
  };

  // mark=false 场景：不授权，按字段对比智能清空（原有逻辑）
  _loadFormWithMarkFalse = () => {
    const { params, onLoad, renderUrl, headers, detail } = this.props;
    const clearedKey = "receptFormDataCleared";
    const hasCleared = sessionStorage.getItem(clearedKey) === "true";

    request({
      url: renderUrl,
      method: "GET",
      headers: { ...headers },
      data: {
        ...params,
        detail: detail ? 1 : undefined,
        t: Date.now(),
      },
    }).then((response) => {
      let res = (response || {}).data || response || {};
      if (!res.formSchema && response && response.data && response.data.data) {
        res = response.data.data;
      }
      let formData = isString(res.formSchema) ? JSON.parse(res.formSchema) : res.formSchema;
      console.log("排查数据", formData);

      if (!hasCleared) {
        formData = this.modifyFormData(formData, params);
        console.log("排查数据后", formData);
        sessionStorage.setItem(clearedKey, "true");
      } else {
        if (!formData.global) formData.global = {};
        formData.global.edit = true;
        formData.global.readonly = false;
        formData.global.disabled = false;

        const processComponent = (component) => {
          if (!component) return;
          if (component.props && component.props.fieldId) {
            component.props.readonly = false;
            component.props.disabled = false;
            component.props.editable = true;
            component.props.readOnly = false;
          }
          if (component.children && Array.isArray(component.children)) {
            component.children.forEach(child => processComponent(child));
          }
        };

        if (formData.pages && Array.isArray(formData.pages)) {
          formData.pages.forEach(page => {
            if (page.layout) processComponent(page.layout);
          });
        }
      }

      this.setState({
        loading: false,
        schema: formData,
        PageMode: get(formData, "pages[0].layout.props.mode", "normal"),
        globalMessage: formData.global && formData.global.globalMessage,
        isEdit: true,
        disableDevicePlugin: formData.global && formData.global.disableDevicePlugin,
      });
    });

    if (onLoad) onLoad(this);
  };

  // 无 mark cookie：正常加载
  _loadFormNormal = () => {
    const { params, onLoad, renderUrl, headers, detail } = this.props;

    request({
      url: renderUrl,
      method: "GET",
      headers: { ...headers },
      data: {
        ...params,
        detail: detail ? 1 : undefined,
        t: Date.now(),
      },
    }).then((response) => {
      let res = (response || {}).data || response || {};
      if (!res.formSchema && response && response.data && response.data.data) {
        res = response.data.data;
      }
      const data = isString(res.formSchema) ? JSON.parse(res.formSchema) : res.formSchema;
      this.setState({
        loading: false,
        schema: data,
        PageMode: get(data, "pages[0].layout.props.mode", "normal"),
        globalMessage: data.global && data.global.globalMessage,
        isEdit: data.global && data.global.edit,
        disableDevicePlugin: data.global && data.global.disableDevicePlugin,
      });
    });

    if (onLoad) onLoad(this);
  };

  componentWillUnmount () {
    console.log(" componentWillUnmount 触发, mark:", Cookies.get('mark'));
    const markCookie = Cookies.get('mark');
    if (markCookie === 'user') {
      if (this.formInstance && this.formInstance.fieldApi) {
        try {
          const result = this.formInstance.fieldApi.getFieldsData({ disableValid: true });
          if (result && result.content) {
            const instanceId = this.state.schema?.instanceData?.id;
            const key = `receptFormUserValues_${instanceId || 'default'}`;
            sessionStorage.setItem(key, JSON.stringify(result.content));
          }
        } catch (e) { console.error("保存失败:", e); }
      }
    }

    if (this.formInstance && this.formInstance.formContext)
    {
      this.formInstance.formContext.emitter.removeListener(
        "reportGroups",
        this.groupChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "pageChange",
        this.pageChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "errorListChange",
        this.errorListChangeHandler
      );
      this.formInstance.formContext.emitter.removeListener(
        "callDeviceSdk",
        this.callDeviceSdkHandler
      );
    }
    this.formLoadingTimer && clearTimeout(this.formLoadingTimer);
  }
  // mark=user 场景：获取需要保留的字段列表（用户填写信息）
  getPreserveFieldIds = async () => {
    const { params = {} } = this.props;
    const matterId = params.matterId || params.matterCode;

    // 根据 URL 中 config 参数是否携带 preview 字段决定 finalVerify：有 preview 为 false，无 preview 为 true
    let hasPreview = false;
    try {
      const url = window.location.href;
      // 匹配 config=%7B...%7D 或 config={...}
      const configMatch = url.match(/[?&]config=([^&]*)/);
      if (configMatch) {
        const configStr = decodeURIComponent(configMatch[1]);
        const configObj = JSON.parse(configStr);
        hasPreview = configObj.preview !== undefined;
      }
    } catch (e) {
      console.error('从 URL 解析 preview 失败:', e);
    }
    const finalVerify = !hasPreview;

    try {
      const res = await request({
        url: '/rest/api/field/visibility/getMatterFieldVisibilityByMatterId',
        method: 'GET',
        params: { matterId, finalVerify },
      });
      const visibilityConfig = res?.data?.visibilityConfig;
      if (visibilityConfig) {
        return new Set(Object.keys(JSON.parse(visibilityConfig)));
      }
    } catch (e) {
      console.error('getPreserveFieldIds 失败:', e);
    }
    return new Set();
  };

  // mark=user 场景：全量清空表单数据，但保留 preserveFieldIds 中指定的字段
  modifyFormDataForUser = (originalData, preserveFieldIds) => {
    try {
      console.log(" [mark=user] 开始全量清空表单数据，保留字段数:", preserveFieldIds.size, [...preserveFieldIds]);

      const data = JSON.parse(JSON.stringify(originalData));

      // 禁用自动填充类请求，但保留数据共享请求（共享请求需要运行才能填入共享字段值）
      if (data.request && Array.isArray(data.request)) {
        data.request.forEach(req => {
          // initial=true 的请求保留（包括数据共享、判断逻辑等初始化请求）
          if (req.initial === true) return;
          req.disabled = true;
        });
      }

      // 排查：打印所有顶层 key 和 instanceData 结构
      console.log("📦 formData 顶层 keys:", Object.keys(data));
      console.log("📦 instanceData keys:", data.instanceData ? Object.keys(data.instanceData) : 'instanceData不存在');
      console.log("📦 instanceData.formData 是否存在:", !!(data?.instanceData?.formData), "长度:", data?.instanceData?.formData?.length);
      // 找 self.IDCARD 在哪
      const idcardInFormData = data?.instanceData?.formData?.find(f => f.fieldId === 'self.IDCARD');
      console.log("📦 self.IDCARD in instanceData.formData:", idcardInFormData ? JSON.stringify(idcardInFormData.fieldData?.value) : '不存在');
      console.log("📦 self.IDCARD in instanceData.data:", data?.instanceData?.data?.['self.IDCARD']);
      console.log("📦 self.IDCARD in data.data:", data?.data?.['self.IDCARD']);
      console.log("📦 self.IDCARD in data.formData:", data?.formData?.['self.IDCARD']);

      // 修改全局配置为可编辑
      if (data.global) {
        data.global.edit = true;
        data.global.readonly = false;
        data.global.disabled = false;
      }

      // 处理页面组件配置 - 全部设置为可编辑，同时清空非保留字段的值
      const processComponent = (component) => {
        if (!component) return;
        if (component.props && component.props.fieldId) {
          const fieldId = component.props.fieldId;
          component.props.readonly = false;
          component.props.disabled = false;
          component.props.editable = true;
          component.props.readOnly = false;

          // 清空 schema 层面的值（非保留字段、非系统字段）
          if (!preserveFieldIds.has(fieldId) && !fieldId.startsWith('system.')) {
            ['value', 'defaultValue', 'initialValue', 'autoValue', 'displayValue'].forEach(prop => {
              if (component.props[prop] !== undefined) {
                component.props[prop] = null;
              }
            });
          }
        }
        if (component.children && Array.isArray(component.children)) {
          component.children.forEach(child => processComponent(child));
        }
      };

      if (data.pages && Array.isArray(data.pages)) {
        data.pages.forEach(page => {
          if (page.layout) processComponent(page.layout);
        });
      }

      // 清空 instanceData.formData 字段值
      // 规则：system.* 保护，preserveFieldIds 保留，其他全清空
      if (data?.instanceData?.formData) {
        data.instanceData.formData.forEach((field, index) => {
          if (!field?.fieldData || !field.fieldId) return;

          const fieldId = field.fieldId;

          // 保护系统字段
          if (fieldId.startsWith('system.')) {
            console.log(` [${index}] 保护系统字段: ${fieldId}`);
            return;
          }

          // 保留接口指定的用户填写字段
          if (preserveFieldIds.has(fieldId)) {
            console.log(` [${index}] 保留用户字段: ${fieldId} = ${JSON.stringify(field.fieldData.value)}`);
            return;
          }

          // 其他全部清空
          const oldValue = field.fieldData.value;
          field.fieldData.value = null;
          field.fieldData.eyeOpenType = false;
          ['defaultValue', 'initialValue', 'autoValue', 'computedValue', 'text', 'label', 'displayValue'].forEach(prop => {
            if (field.fieldData[prop] !== undefined) {
              field.fieldData[prop] = null;
            }
          });
          console.log(` [${index}] 清空字段: ${fieldId} - 原值: ${JSON.stringify(oldValue)} -> null`);
        });
      }

      // 清空其他数据结构（instanceData.data / formData / initialData / data）
      const clearDataStructure = (dataObj, structureName) => {
        if (!dataObj) return;
        Object.keys(dataObj).forEach(key => {
          if (key.startsWith('system.')) return;
          if (preserveFieldIds.has(key)) {
            console.log(` 保留 ${structureName}.${key}`);
            return;
          }
          dataObj[key] = null;
        });
      };

      if (data.instanceData) {
        ['data', 'initialData', 'defaultData', 'values'].forEach(prop => {
          if (data.instanceData[prop] && typeof data.instanceData[prop] === 'object' && !Array.isArray(data.instanceData[prop])) {
            clearDataStructure(data.instanceData[prop], `instanceData.${prop}`);
          }
        });
      }
      if (data.formData) clearDataStructure(data.formData, 'formData');
      if (data.initialData) clearDataStructure(data.initialData, 'initialData');
      if (data.data) clearDataStructure(data.data, 'data');

      console.log(" [mark=user] 全量清空完成");
      return data;
    } catch (error) {
      console.error(" [mark=user] 表单处理失败:", error);
      return originalData;
    }
  };

  modifyFormData = (originalData, params) => {
    try
    {
      console.log(" 开始处理表单数据，清空所有字段", originalData);

      // 深拷贝防止修改原始数据对象，避免引用问题
      const data = JSON.parse(JSON.stringify(originalData));

      //  收集 pages 中所有的 fieldId
      const pagesFieldIds = new Set();
      const collectFieldIds = (component) => {
        if (!component) return;

        if (component.props && component.props.fieldId)
        {
          pagesFieldIds.add(component.props.fieldId);
        }

        if (component.children && Array.isArray(component.children))
        {
          component.children.forEach(child => collectFieldIds(child));
        }
      };

      if (data.pages && data.pages.length > 0)
      {
        data.pages.forEach(page => {
          if (page.layout)
          {
            collectFieldIds(page.layout);
          }
        });
      }

      //  收集 instanceData.formData 中所有的 fieldId
      const instanceDataFieldIds = new Set();
      if (data?.instanceData?.formData)
      {
        data.instanceData.formData.forEach(field => {
          if (field.fieldId)
          {
            instanceDataFieldIds.add(field.fieldId);
          }
        });
      }
      console.log(instanceDataFieldIds, pagesFieldIds, "测试")
      //  找出两者的交集 - 这些是真正存在且有效的字段
      const validFieldIds = new Set([...pagesFieldIds].filter(id => instanceDataFieldIds.has(id)));

      //  找出只在 pages 中存在的字段（可能是显示字段）
      const pagesOnlyFields = new Set([...pagesFieldIds].filter(id => !instanceDataFieldIds.has(id)));

      //  找出只在 instanceData 中存在的字段（可能是隐藏数据字段）
      const instanceOnlyFields = new Set([...instanceDataFieldIds].filter(id => !pagesFieldIds.has(id)));

      console.log(" 字段分析结果:");
      console.log(`  - pages 中的字段数量: ${pagesFieldIds.size}`);
      console.log(`  - instanceData 中的字段数量: ${instanceDataFieldIds.size}`);
      console.log(`  - 有效字段数量 (两者都有): ${validFieldIds.size}`);
      console.log(`  - 仅在 pages 中的字段: ${pagesOnlyFields.size}`, [...pagesOnlyFields]);
      console.log(`  - 仅在 instanceData 中的字段: ${instanceOnlyFields.size}`, [...instanceOnlyFields]);

      //  定义需要特殊保护的字段
      const protectedFields = new Set([
        'self.SXWYM63',  // 事项唯一码
        'self.SXMLBM',   // 事项目录编码
      ]);

      //  处理自动请求配置
      if (data.request && Array.isArray(data.request))
      {
        data.request.forEach((req, index) => {
          // 保留"获取事项唯一码"请求，其他禁用
          if (req.desc === '获取事项唯一码')
          {
            console.log(` 保留请求: ${req.desc}`);
          } else
          {
            if (req.initial === true)
            {
              req.initial = false;
            }
            req.disabled = true;
            if (req.desc && (
              req.desc.includes('自动填充') ||
              req.desc.includes('数据共享') ||
              req.desc.includes('根据') ||
              req.desc.includes('基于')
            ))
            {
              console.log(` 禁用自动请求填充请求: ${req.desc}`);
              req.initial = false;
              req.disabled = true;
            }
          }
        });
      }

      //  修改全局配置
      if (data.global)
      {
        console.log(' 修改表单全局配置: edit false -> true');
        data.global.edit = true;
        data.global.readonly = false;
        data.global.disabled = false;
      }

      //  处理页面组件配置 - 只处理有效字段
      if (data.pages && data.pages.length > 0)
      {
        data.pages.forEach((page, pageIndex) => {
          console.log(` 处理页面 ${pageIndex}`);

          const processComponent = (component) => {
            if (!component) return;

            if (component.props && component.props.fieldId)
            {
              const fieldId = component.props.fieldId;

              //  只处理有效字段或受保护字段
              if (validFieldIds.has(fieldId) || protectedFields.has(fieldId))
              {
                component.props.readonly = false;
                component.props.disabled = false;
                component.props.editable = true;
                component.props.readOnly = false;

                console.log(` 设置字段可编辑: ${fieldId}`);
              } else if (pagesOnlyFields.has(fieldId))
              {
                console.log(` 仅显示字段，不处理数据: ${fieldId}`);
              }
            }

            // 递归处理子组件
            if (component.children && Array.isArray(component.children))
            {
              component.children.forEach(child => processComponent(child));
            }
          };

          if (page.layout)
          {
            processComponent(page.layout);
          }
        });
      }

      //   清空表单字段数据 - 只清空有效字段，保护系统字段和特殊字段
      if (data?.instanceData?.formData)
      {
        console.log(" 开始清空字段值，但保护系统字段和特殊字段");

        data.instanceData.formData.forEach((field, index) => {
          if (field?.fieldData && field.fieldId)
          {
            const fieldId = field.fieldId;

            //  保护系统字段
            if (fieldId.startsWith('system.'))
            {
              console.log(` [${index}] 保护系统字段: ${fieldId}`);
              return;
            }

            //  保护特殊字段
            if (protectedFields.has(fieldId))
            {
              console.log(` [${index}] 保护特殊字段: ${fieldId} = ${JSON.stringify(field.fieldData.value)}`);
              return;
            }

            //  只清空有效字段（在 pages 中也存在的字段）
            if (validFieldIds.has(fieldId))
            {
              const oldValue = field.fieldData.value;
              field.fieldData.value = null;
              field.fieldData.eyeOpenType = false;

              // 清空其他相关属性
              ['defaultValue', 'initialValue', 'autoValue', 'computedValue', 'text', 'label', 'displayValue'].forEach(prop => {
                if (field.fieldData[prop] !== undefined)
                {
                  field.fieldData[prop] = null;
                }
              });

              console.log(` [${index}] 清空有效字段: ${fieldId} (${field.componentName}) - 原值: ${JSON.stringify(oldValue)} -> null`);
            } else if (instanceOnlyFields.has(fieldId))
            {
              console.log(` [${index}] 仅在数据中的字段，暂不处理: ${fieldId} = ${JSON.stringify(field.fieldData.value)}`);
            }
          }
        });
      }

      //  清空其他数据结构 - 只清空有效字段
      const clearDataStructure = (dataObj, structureName) => {
        if (!dataObj) return;

        console.log(` 清空 ${structureName}`);
        Object.keys(dataObj).forEach(key => {
          // 保护系统字段
          if (key.startsWith('system.'))
          {
            console.log(` 保护 ${structureName}.${key}`);
            return;
          }

          // 保护特殊字段
          if (protectedFields.has(key))
          {
            console.log(` 保护特殊字段 ${structureName}.${key}`);
            return;
          }

          // 只清空有效字段
          if (validFieldIds.has(key))
          {
            const oldValue = dataObj[key];
            dataObj[key] = null;
            console.log(` 清空 ${structureName}.${key}: ${JSON.stringify(oldValue)} -> null`);
          } else
          {
            console.log(` 跳过非有效字段 ${structureName}.${key}`);
          }
        });
      };

      // 处理各种数据结构
      if (data.instanceData)
      {
        ['data', 'initialData', 'defaultData', 'values'].forEach(prop => {
          if (data.instanceData[prop] && typeof data.instanceData[prop] === 'object' && !Array.isArray(data.instanceData[prop]))
          {
            clearDataStructure(data.instanceData[prop], `instanceData.${prop}`);
          }
        });
      }

      if (data.formData)
      {
        clearDataStructure(data.formData, 'formData');
      }

      if (data.initialData)
      {
        clearDataStructure(data.initialData, 'initialData');
      }

      if (data.data)
      {
        clearDataStructure(data.data, 'data');
      }

      //  设置全局标记清空所有字段
      window.__CLEAR_ALL_FIELDS__ = true;

      //  延迟清空DOM元素
      setTimeout(() => {
        console.log(" 延迟清空DOM操作");
        document.querySelectorAll('input, select, textarea').forEach(element => {
          // 清空值
          if (element.value && element.value !== '' && element.value !== '请选择')
          {
            console.log(` 延迟清空DOM: ${element.placeholder || element.name || 'input'} = "${element.value}"`);
            element.value = '';
            element.dispatchEvent(new Event('input', { bubbles: true }));
            element.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // 禁止自动填充
          element.setAttribute('autocomplete', 'off');
          element.setAttribute('autocapitalize', 'off');
          element.setAttribute('autocorrect', 'off');
          element.setAttribute('spellcheck', 'false');
        });
      }, 1000);

      console.log(" 表单处理完成，基于字段对比的智能清空已完成");
      console.log(` 处理统计: 保护了 ${protectedFields.size} 个特殊字段，清空了 ${validFieldIds.size} 个有效字段`);

      return data;
    } catch (error)
    {
      console.error(" 表单处理失败:", error);
      return originalData;
    }
  };
  onFormReady = (instance) => {
    this.formInstance = instance;
    console.log(" formInstance keys:", Object.keys(instance || {}));
    this.formInstance.formContext.emitter.on(
      "pageChange",
      this.pageChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "reportGroups",
      this.groupChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "errorListChange",
      this.errorListChangeHandler
    );
    this.formInstance.formContext.emitter.on(
      "callDeviceSdk",
      this.callDeviceSdkHandler
    );
  };

  getErrorPages () {
    const errorFieldIds =
      this.formInstance.formContext.getGlobal("errorFieldIds");
    const errorPage = {};

    if (errorFieldIds)
    {
      errorFieldIds.forEach((fieldId) => {
        errorPage[this.formInstance.stepManager.getPageById(fieldId)] = true;
      });
    }
    return Object.keys(errorPage);
  }

  pageChangeHandler = (index) => {
    const errorPages = this.getErrorPages();

    this.setState(
      {
        currentPage: index,
        pages: this.formInstance.stepManager.pages.map((item, pageIndex) => {
          return {
            ...item,
            hasError: errorPages.includes(item.id),
            disabled: this.formInstance.stepManager.travel + 1 < pageIndex,
          };
        }),
      },
      () => {
        this.formInstance.fieldApi.turnPages(
          this.state.currentPage,
          this.state.pages.map((item) => item.id)
        );
        this.props.onPageChange &&
          this.props.onPageChange(this.state.currentPage);
      }
    );
  };

  groupChangeHandler = (groups) => {
    if (this.formInstance && this.formInstance.stepManager)
    {
      const errorFieldIds =
        this.formInstance.formContext.getGlobal("errorFieldIds");
      if (errorFieldIds)
      {
        const errorPages = this.getErrorPages();

        this.setState(({ pages }) => {
          return {
            pages: pages.map((item) => {
              return {
                ...item,
                hasError: errorPages.includes(item.id),
              };
            }),
          };
        });
      }
    }
    this.setState({ groups });
  };

  errorListChangeHandler = ({ visible, errorList, globalErrorList } = {}) => {
    const result = {};
    !isNil(visible) && Object.assign(result, { errorListVisible: visible });
    !isNil(errorList) && Object.assign(result, { errorList });
    !isNil(globalErrorList) && Object.assign(result, { globalErrorList });
    this.setState(result);
  };

  callDeviceSdkHandler = ({ visible, status } = {}) => {
    const targetState = {};
    visible !== undefined &&
      Object.assign(targetState, { sdkVisible: visible });
    status !== undefined && Object.assign(targetState, { sdkStatus: status });
    this.setState(targetState);
  };

  triggerScrollGroup = (key) => {
    if (this.formInstance)
    {
      this.formInstance.fieldApi.scrollToGroup(key);
    }
  };

  triggerScrollField = (key) => {
    if (this.formInstance)
    {
      if (this.formInstance.stepManager)
      {
        const page = this.formInstance.stepManager.getPageById(key);
        !isNil(page) && this.formInstance.stepManager.goPage(page);
      }
      this.formInstance.fieldApi.scrollToField(key);
    }
  };

  getErrorMsg = (options) => {
    return this.formInstance && this.formInstance.fieldApi.getErrorMsg(options);
  };

  save = (event) => {
    const { submitHandler } = this.props;

    if (!this.formInstance)
    {
      submitHandler({ success: false, errorMsg: "表单仍在加载中", event });
    }

    const mode = this.state.PageMode;

    if (
      event === "submit" &&
      mode === "step" &&
      this.state.currentPage < this.state.pages.length - 1
    )
    {
      return this.savePage()
        .then((res) => {
          submitHandler({
            ...res,
            event,
            mode,
          });
          if (!res || !res.success)
          {
            return;
          }
          this.formInstance.stepManager.next();
        })
        .catch((res) => {
          if (res.stack)
          {
            submitHandler({ success: false, errorMsg: res, event, mode });
          } else
          {
            submitHandler({ ...res, success: false, event, mode });
          }
        });
    }

    let options = {};
    if (event === "submit")
    {
      options = { actionCode: "FormSubmit" };
    }
    if (event === "saveDraft")
    {
      options = {
        actionCode: "SaveFormDraft",
        draft: true,
        noValid: true,
      };
    }
    this.formInstance.submitManager
      .save(options)
      .then((res) => {
        submitHandler({ ...res, event, mode });
      })
      .catch((res) => {
        if (res.stack)
        {
          submitHandler({ ...res, success: false, errorMsg: res, event, mode });
        } else
        {
          submitHandler({ ...res, success: false, event, mode });
        }
      });
  };

  savePage = () => {
    const fieldIds = this.formInstance.stepManager.getFieldIds();
    return this.formInstance.submitManager.savePage(fieldIds);
  };

  prevPage = () => {
    this.formInstance.stepManager.prev();
  };

  nextPage = () => {
    const mode = this.state.PageMode;

    if (
      mode === "step" &&
      this.state.currentPage < this.state.pages.length - 1
    )
    {
      return this.savePage().then((result) => {
        if (!result || !result.success)
        {
          return;
        }
        this.formInstance.stepManager.next();
      });
    }
  };

  // todo 测试代码，需要删除
  getFieldsSelectData () {
    const data = this.formInstance.formContext.getGlobal() || {};
    console.log("fields data", data);
  }

  // todo 测试代码，需要删除
  setFieldsSelectData () {
    console.log("delete", this.state.fieldsSelectModeData.slice(0, 1));
    this.setState({
      fieldsSelectModeData: this.state.fieldsSelectModeData.slice(0, 1),
    });
  }

  // 表单项选择模式，选中表单项改变的方法
  onFieldsSelectChange (params) {
    // 重新包装props.onFieldsSelectChange，解决hooks对象传方法时的闭包问题
    typeof this.props.onFieldsSelectChange === "function" &&
      this.props.onFieldsSelectChange(params);

    this.setState({ formLoading: true }, () => {
      this.formLoadingTimer = setTimeout(
        () => this.setState({ formLoading: false }),
        100
      );
    });

    // // todo 测试代码，需要删除
    // const { checked, currentData, selectedData } = params;
    // console.log("fields select change", checked, currentData, selectedData);
    // this.setState({
    //   fieldsSelectModeData: [...selectedData],
    // });
  }

  render () {
    const { detail, matters } = this.props;
    const {
      groups,
      schema,
      globalMessage,
      loading,
      isEdit,
      disableDevicePlugin,
      pages,
      currentPage,
      errorListVisible,
      errorList,
      globalErrorList,
      sdkVisible,
      sdkStatus,
    } = this.state;
    if (loading)
    {
      return <Loading tip="加载中..." style={{ width: "100%", height: 220 }} />;
    }

    // TODO: FormNav 应该和 FormStep 通过策略模式来做，后面有时间再重构
    // <Container type="normal|step"><GlobalMessage/><Form/></Container>
    let mode;
    if (detail)
    {
      mode = "normal";
    } else
    {
      mode = this.state.PageMode;
    }
    const shouldShowStep = mode === "step" && pages.length > 1;

    const sdkStyleMap = {
      gpy: { width: "1000px", height: "636px" },
    };

    const sdkProps = {
      ...sdkStyleMap[sdkStatus],
      gpyTotal: "9",
      status: sdkStatus,
      visible: sdkVisible,
      closeDialog: () => {
        this.setState({ sdkVisible: false });
      },
      fail: () => {
        Message.warning("设备连接失败");
      },
      success: (data) => {
        // 调用sdk记录设备调用返回结果
        this.formInstance.formContext.emitter.emit(
          "callDeviceSdkSuccess",
          data
        );
      },
    };

    return (
      <div>
        {/* TODO 待删 */}
        {/* <Button onClick={this.getFieldsSelectData}>获取表单选项数据</Button>
        <Button onClick={this.setFieldsSelectData}>删除选项</Button>
        <Button
          onClick={() =>
            this.setState({
              fieldsSelectModeStatus: !this.state.fieldsSelectModeStatus,
              fieldsSelectModeData: this.state.fieldsSelectModeData,
            })
          }
        >
          切换选择模式
        </Button> */}
        {/* 分组模式 */}
        {mode === "normal" && !detail && (
          <FormNav groups={groups} triggerScroll={this.triggerScrollGroup} />
        )}
        {/* 分步模式 */}
        {mode === "step" && shouldShowStep && (
          <NavBar
            dataSource={pages}
            currentStep={currentPage}
            onClick={(index) => {
              if (index <= this.state.currentPage)
              {
                this.formInstance.stepManager.go(index);
              } else
              {
                this.savePage().then((result) => {
                  if (!result || !result.success)
                  {
                    return;
                  }
                  this.formInstance.stepManager.go(index);
                });
              }
            }}
          />
        )}
        {globalMessage && <GlobalMessage message={globalMessage} />}
        <ErrorTab
          visible={errorListVisible}
          errorList={errorList}
          globalErrorList={globalErrorList}
          triggerScroll={this.triggerScrollField}
        />
        {schema && (
          <Loading visible={this.state.formLoading} inline={false}>
            <Form
              {...this.props}
              formOptions={this.props.formOptions || {}}
              // // todo 待优化
              // formOptions={{
              //   fieldsSelectModeStatus: this.state.fieldsSelectModeStatus,
              //   fieldsSelectModeData: this.state.fieldsSelectModeData,
              // }}
              onFieldsSelectChange={this.onFieldsSelectChange}
              isEdit={isEdit}
              disableDevicePlugin={disableDevicePlugin}
              schema={schema}
              initErrorMsg={this.props.initErrorMsg || mode === "step"}
              onFormReady={this.onFormReady}
            />
          </Loading>
        )}
        <DeviceSdk originProps={sdkProps} only="true" />
      </div>
    );
  }
}

ReceptForm.defaultProps = {
  detail: false,
  initErrorMsg: false,
  endpoint: "online",
  renderUrl: "/form/formrender",
  submitUrl: "/api/reception/execute",
  params: {},
  formOptions: {},
};

ReceptForm.propTypes = {
  detail: PropTypes.bool,
  initErrorMsg: PropTypes.bool,
  endpoint: PropTypes.string,
  renderUrl: PropTypes.string,
  submitUrl: PropTypes.string,
  getResourceUrl: PropTypes.string,
  params: PropTypes.object,
  formOptions: PropTypes.object, // 表单配置参数
  onFieldsSelectChange: PropTypes.func, // 表单项选择模式，选择选项是的回调
};

export default ReceptForm;
